module.exports = __webpack_public_path__ + "static/img/biaoti.c8f6399.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cockpit/biaoti.png
// module id = CkDk
// module chunks = 1